/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
import Control from "sap/ui/core/Control";
import UI5Element from "sap/ui/core/Element";
import RenderManager from "sap/ui/core/RenderManager";

export class RenderManagerClosures {
    renderManager: RenderManager;
    idPrefix: string;
    constructor(renderManager: RenderManager, idPrefix = "") {
        this.renderManager = renderManager;
        this.idPrefix = idPrefix;
    }
    render(tag: string, id: string | UI5Element, clazzes: Array<string>, body: () => void) {
        if (typeof id === "string" && id.length > 0) {
            id = this.idPrefix + id;
        }
        this.renderManager.openStart(tag, id);
        clazzes.forEach((clazz) => this.renderManager.class(clazz));
        this.renderManager.openEnd();
        body();
        this.renderManager.close(tag);
    }
    text(text: string) {
        this.renderManager.text(text);
    }
    renderControl(control: Control) {
        this.renderManager.renderControl(control);
    }
}
